import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=59236500&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=ts"
export * from "./Rule.vue?vue&type=script&lang=ts"
import style0 from "./Rule.vue?vue&type=style&index=0&id=59236500&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59236500",
  null
  
)

export default component.exports